<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col-l2 mb-2">
      <h4 class="mb-0 font-header-1">PayRoll</h4>
    </div>
    <div class="col pl-0 mt-2">
      <div widget class="card border-0 box-shadow">
        <div class="card-body transparent  text-muted">
          <!-- row1 -->
          <!-- <div class="row ms-3">
          <div class=" col-lg-12">
            <div class="row">
              <div class="col-lg-3 col-md-5 col-sm-6 col-xs-12 ">
                <div class="row">
                  <div class="col-lg-5 ">
                    <span>Start date</span>
                  </div>
                  <div class="col-lg-7 ">
                    <my-date-picker [options]="myDatePickerOptions" [selDate]="filterStartDate" placeholder="mm/dd/yyyy"
                      (inputFieldChanged)="payDateChanges($event,'inputchanged','startDate')"
                      (dateChanged)="payDateChanges($event,'datechanged','startDate')"
                      >
                    </my-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-5 col-sm-6 col-xs-12  ">
                <div class="row">
                  <div class="col-lg-5 ">
                    <span>End date</span>
                  </div>
                  <div class="col-lg-7 ">
                    <my-date-picker [options]="myDatePickerOptions" [selDate]="filterEndDate" placeholder="mm/dd/yyyy"
                      (inputFieldChanged)="payDateChanges($event,'inputchanged','endDate')"
                      (dateChanged)="payDateChanges($event,'datechanged','endDate')"
                     >
                    </my-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-5 col-sm-6 col-xs-12  ">
                <div class="row">
                  <div class="col-lg-5 ">
                    <span>Pay date</span>
                  </div>
                  <div class="col-lg-7 ">
                    <my-date-picker [options]="myDatePickerOptions" [selDate]="filterPayDate" placeholder="mm/dd/yyyy"
                      (inputFieldChanged)="payDateChanges($event,'inputchanged','payDatedFilter')"
                      (dateChanged)="payDateChanges($event,'datechanged','payDatedFilter')"
                     >
                    </my-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 text-end ms-2">
                <button type="button" class="btn me-3" (click)="ApplyFilter()"
                     >Apply</button>
                <button type="button" class="btn me-2"  (click)="Refresh()"
                >
                <i class="fa fa-repeat"> </i>Refresh
              </button>
              </div>
            </div>
          </div>
        </div> -->
          <!-- row2 -->
          <!-- <div class="row ms-3 mt-3">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-4 col-md-5 col-sm-6 col-xs-12">
                <div class="row">
                  <div class="col-lg-3 ">
                    <span>Employee</span>
                  </div>
                  <div class="col-lg-7">
                    <ng-select 
                      [clearable]="true" [items]="Employeedropdown" bindValue="Key" bindLabel="Value"
                      [(ngModel)]="employeeFilterList">
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-5 col-sm-6 col-xs-12">
                <div class="row">
                  <div class="col-lg-3 ">
                    <span>Client</span>
                  </div>
                  <div class="col-lg-7">
                    <ng-select 
                      [searchable]="true" [clearable]="true" [items]="clientAlldropdown" bindLabel="Value"
                      bindValue="Key" [(ngModel)]="clientFilterList">
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-5 col-sm-6 col-xs-12">
                <div class="row">
                  <div class="col-lg-2">
                    <span>Service</span>
                  </div>
                  <div class="col-lg-9">
                    <ng-select  [(ngModel)]="PayrollListBo.serviceId"  [searchable]="true" [clearable]="true"
                                    [items]="serviceList" bindLabel="Value" bindValue="Key">
                                  </ng-select>
                  </div>
                </div>
              </div>
           

            </div>
          </div>
        </div> -->

          <!-----Row-->
          <div class="row mb-2">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <span>Start date</span>
              <my-date-picker [options]="myDatePickerOptions" [selDate]="filterStartDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="payDateChanges($event,'inputchanged','startDate')"
                (dateChanged)="payDateChanges($event,'datechanged','startDate')">
              </my-date-picker>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <span>End date</span>
              <my-date-picker [options]="myDatePickerOptions" [selDate]="filterEndDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="payDateChanges($event,'inputchanged','endDate')"
                (dateChanged)="payDateChanges($event,'datechanged','endDate')">
              </my-date-picker>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12" *ngIf="PrivatePaySelectedTab == 'Paid'">
              <span>Pay date</span>
              <my-date-picker [options]="PayDatePickerOptions" [selDate]="filterPayDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="payDateChanges($event,'inputchanged','payDatedFilter')"
                (dateChanged)="payDateChanges($event,'datechanged','payDatedFilter')">
              </my-date-picker>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <span>Employee</span>
              <ng-select [clearable]="true" [items]="Employeedropdown" bindValue="Key" bindLabel="Value"
                [(ngModel)]="employeeFilterList">
              </ng-select>
            </div>
          </div>

          <div class="row mt-2 mb-2">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <span>Client</span>
              <ng-select [searchable]="true" [clearable]="true" [items]="clientAlldropdown" bindLabel="Value"
                bindValue="Key" [(ngModel)]="clientFilterList">
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <span>Service</span>
              <ng-select [(ngModel)]="PayrollListBo.serviceId" [searchable]="true" [clearable]="true"
                [items]="serviceList" bindLabel="Value" bindValue="Key">
              </ng-select>
            </div>
                                    <div class="col-lg-4 col-11 mt-3" >
                            <input type="radio" class="mt-3" name="all" value="all"
                            [(ngModel)]="ApproveFilter" (change)="ApplyFilter()"> &nbsp; All
                        <input type="radio" class="ms-1" name="all" value="approved"
                            [(ngModel)]="ApproveFilter" (change)="ApplyFilter()"> &nbsp;Approved
                        <input type="radio" class="ms-1" name="all" value="notapproved"
                            [(ngModel)]="ApproveFilter" (change)="ApplyFilter()"> &nbsp; Not
                        Approved

                        </div>
            <div class="col-lg-5 mt-4 col-md-6 col-sm-12">
              <button type="button" class="btn btn-sm me-3" (click)="ApplyFilter()">Apply</button>
              <button type="button" class="btn btn-sm me-3" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"
                *ngIf="PaidPayrollCount > 0 && PrivatePaySelectedTab == 'Paid'">
                <i class="fa fa-file-excel-o "></i>Export</button>
              <button type="button" class="btn btn-sm me-3" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"
                *ngIf="UnPaidPayrollCount > 0 && PrivatePaySelectedTab == 'UnPaid'">
                <i class="fa fa-file-excel-o "></i>Export</button>
              <button *ngIf="PrivatePaySelectedTab == 'UnPaid'" [disabled]="selectedpayrollid?.length==0"
                (click)="clearpaydate()" class="btn btn-sm  me-3 " data-bs-toggle="modal"
                data-bs-target="#UploadPayDateModal">
                Paydate</button>
              <button *ngIf="PrivatePaySelectedTab != 'UnPaid'" [disabled]=" !paidboolean" (click)="clearpaydate()"
                class="btn btn-sm me-3" data-bs-toggle="modal" data-bs-target="#UploadPayDateModal">
                Paydate</button>
              <button type="button" class="btn btn-sm me-3" (click)="Refresh()">
                <i class="fa fa-repeat"> </i>Refresh
              </button>
              <button type="button" *ngIf="PrivatePaySelectedTab=='Paid'" [disabled]="!paidboolean" class="btn btn-sm"
                data-bs-toggle="modal" data-bs-target="#moveunpaid">
                UnPaid
              </button>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12" style="height:auto">
              <section id="tabs" class="project-tab">
                <!-- <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <button type="button" *ngIf="PrivatePaySelectedTab=='Paid'" [disabled]="!paidboolean"
                      class="btn btn-sm ms-4 mb-1" data-bs-toggle="modal" data-bs-target="#moveunpaid">
                      UnPaid
                    </button>



                  </div>
                </div> -->
                <div class="row">
                  <div class="col-lg-12">
                    <nav>
                      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-unlocked-tab" data-bs-toggle="tab"
                          href="#nav-unlocked" role="tab" aria-controls="nav-unlocked" aria-selected="true"
                          (click)="tabchange('UnPaid')" [ngClass]="{
                        'mytab-inactive':
                          PrivatePaySelectedTab != 'UnPaid',
                        active: PrivatePaySelectedTab == 'UnPaid'
                      }">UnPaid
                        </a>
                        <a class="nav-item nav-link" id="nav-active-tab" data-bs-toggle="tab" href="#nav-active"
                          role="tab" aria-controls="nav-active-tab" aria-selected="false" (click)="tabchange('Paid')"
                          [ngClass]="{
                        'mytab-inactive': PrivatePaySelectedTab != 'Paid',
                        active: PrivatePaySelectedTab == 'Paid'
                      }">Paid</a>

                      </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                      <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                        aria-labelledby="nav-unlocked-tab" [ngClass]="{
                      active: PrivatePaySelectedTab == 'UnPaid',
                      show: PrivatePaySelectedTab == 'UnPaid'
                    }">
                        <!-- UnLocked  ejs-grid -->
                        <div class="row mb-2 mt-1">

                          <div class="col-lg-12 pl-0">
                            <ejs-grid #grid [dataSource]="GridList | async" [allowResizing]='true' [allowSorting]='true'
                              [allowFiltering]='true' [allowPaging]='true' [pageSettings]='initialPage'
                              [filterSettings]='filterSettings' [showColumnChooser]='true'
                              (checkBoxChange)="checkboxunpaidchange($event)" (rowDataBound)='rowDataBound($event)'
                              (dataStateChange)='dataStateChange($event)' (actionBegin)="actionBegin($event)"
                              [selectionSettings]='selectionOptions'>
                              <e-columns>

                                <!-- <e-column  width='5%'></e-column> -->
                                <e-column type='checkbox' minWidth=50 textAlign='left' [allowEditing]='true'
                                  [edit]='checkparams' [showInColumnChooser]='false'>
                                </e-column>
                                <e-column minWidth=50 headerText="Actions" textAlign='center'
                                  [showInColumnChooser]='false'>
                                  <ng-template #template let-data>
                                    <div>
                                      <button class="btn blue-btn btn-sm ms-1" (click)="editPaydate($event)"
                                        data-bs-toggle="modal"
                                        [disabled]="data.payrollPayRateBO.totalAmount==null||data.payrollPayRateBO.totalAmount==undefined||data.payrollPayRateBO.totalAmount==''||data.payrollPayRateBO.totalAmount==0"
                                        data-bs-target="#UploadPayDateModal"><i class="fa fa-edit"></i></button>



                                    </div>
                                  </ng-template>
                                </e-column>
                                <e-column field='clientName' headerText='Client' minWidth=100 textAlign='left'
                                  type="string">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column field='employeeName' headerText='Employee' minWidth=100 textAlign='left'
                                  type="string">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column field='isApproved' headerText="Is Visit Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>
                                <e-column minWidth=100 field="serviceName" headerText="Service Name" type="string">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>

                                <!-- Rate -->
                                <e-column minWidth=100 field="payrollPayRateBO.rate" headerText="Rate" type="number">
                                </e-column>
                                <e-column minWidth=100 field="serviceDate" [format]='formatOptions'
                                  headerText="Timesheet Date" type="date">
                                </e-column>
                                <e-column field='hours' minWidth=100 headerText='Total hrs' textAlign='left'
                                  type="number">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>
                                <e-column field='payrollPayRateBO.totalAmount' minWidth=100 headerText='Total Amt.'
                                  textAlign='left' type="number">
                                  <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                  </ng-template>
                                </e-column>



                                <!--------------------------------table header icon---------------->
                                <!-- <e-column width="50" [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                              <div class="d-none d-lg-block">
                                <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                    aria-hidden="true">
                                  </i></span>
                              </div>
                            </ng-template>
                          </e-column> -->
                              </e-columns>
                            </ejs-grid>
                          </div>

                        </div>
                      </div>
                      <div class="tab-pane fade" id="nav-active" role="tabpanel" aria-labelledby="nav-active-tab"
                        [ngClass]="{
                      active: PrivatePaySelectedTab == 'Paid',
                      show: PrivatePaySelectedTab == 'Paid'
                    }">
                        <!-- Locked  ejs-grid  -->
                        <div class="row p-2" class="e-resizable">
                          <div class="col-lg-12" width="200%">
                            <div class="control section">
                              <ejs-grid #gridpaid [dataSource]='data | async' [allowResizing]='true'
                                (checkBoxChange)="checkboxpaidchange($event)" [allowSorting]='true' [allowPaging]='true'
                                [allowFiltering]='false' [pageSettings]='initialPage'
                                (actionBegin)="actionBeginpaid($event)" [filterSettings]='filterOptions'
                                [showColumnChooser]='true' [childGrid]='childGrid'
                                (dataStateChange)='dataStateChange1($event)' [selectionSettings]='selectionOptions'>
                                <e-columns>
                                  <e-column type='checkbox' minWidth=50 textAlign='left' [allowEditing]='true'
                                    [edit]='checkparams' [showInColumnChooser]='false'>
                                  </e-column>
                                  <e-column minWidth=50 headerText="Actions" textAlign="center"
                                    [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                      <button class="btn btn-edit-table" data-bs-toggle="modal"
                                        [disabled]="data.payrate==null||data.payrate==0||data.payrate==undefined||data.payrate==''"
                                        (click)="editPaydate($event)" data-bs-target="#UploadPayDateModal"><i
                                          class="fa fa-edit"></i></button>&nbsp;

                                    </ng-template>
                                  </e-column>
                                  <e-column field='clientName' headerText='Client' minWidth=100 textAlign='left'
                                    type="string">
                                    <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value">
                                      </ejs-maskedtextbox>
                                    </ng-template>
                                  </e-column>
                                  <e-column field='employeeName' headerText='Employee' minWidth=100 textAlign='left'
                                    type="string">
                                    <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value">
                                      </ejs-maskedtextbox>
                                    </ng-template>
                                  </e-column>
                                  <e-column minWidth=100 field="payDate" headerText="Paid On" [allowEditing]='false'
                                    width=100 type='date' [format]='formatOptions'></e-column>

                                  <e-column minWidth=100 field="serviceName" headerText="Service Name" type="string">
                                    <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                  </e-column>
                              <e-column field='isApproved' headerText="Is Visit Approved" minWidth=80 [allowFiltering]="false" [allowSorting]="false"
                                                textAlign='center' >
                                                <ng-template #template let-data>
                                                    <i class="fa fa-times" *ngIf='data.isApproved==false' 
                                                            style="font-size:27px;color:red"></i>
                                                    <i class="fa fa-check" *ngIf='data.isApproved==true'
                                                        style="font-size:27px;color:green"></i>
                                                        
                                                   
                                                </ng-template>
                                            </e-column>
                                  <!-- Rate -->
                                  <e-column minWidth=100 field="payrate" headerText="Rate" type="number">
                                  </e-column>
                                  <e-column minWidth=100 field="serviceDate" [format]='formatOptions'
                                    headerText="Timesheet Date" type="date">
                                  </e-column>
                                  <e-column field='hours' minWidth=100 headerText='Total hrs' textAlign='left'
                                    type="number">
                                    <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value">
                                      </ejs-maskedtextbox>
                                    </ng-template>
                                  </e-column>
                                  <e-column field='totalAmount' minWidth=100 headerText='Total Amt.' textAlign='left'
                                    type="number">
                                    <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value">
                                      </ejs-maskedtextbox>
                                    </ng-template>
                                  </e-column>




                                  <!--------------------------------table header icon---------------->
                                  <!-- <e-column width="50" [showInColumnChooser]='false'>
                              <ng-template #headerTemplate let-data>
                                <div class="d-none d-lg-block">
                                  <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                      aria-hidden="true">
                                    </i></span>
                                </div>
                              </ng-template>
                            </e-column> -->
                                </e-columns>
                              </ejs-grid>


                            </div>
                          </div>
                          <div class="col-lg-12">
                            <!-- <div *ngIf="LockedDataList.length == 0" class="text-center" style="color:red">
                          <p>No data available</p>
                        </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>







<!-- //////////////////Update  Paydate//////////// -->
<span id="OpenModal3" data-bs-target="#UploadPayDateModal" data-bs-toggle="modal"></span>
<div class="modal fade " id="UploadPayDateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">

  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Edit Paydate</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
                    <p>{{saveErr}}</p>
                    <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div> -->
        <div>
          <div class="row">
            <div class="col-lg-4">
              <label>Pay Date</label>
            </div>
            <div class="col-lg-8">
              <my-date-picker [options]="PayDatePickerOptions" [selDate]="payrollPayDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="editPayrollPaydate($event)" (dateChanged)="editPayrollPaydatechage($event)">
              </my-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="text_right">
          <button class="btn blue-btn btn-sm me-1" type="button" (click)="UpdatePaydate()"
            [disabled]="IsButtonDisable || payrollPayDate==null||payrollPayDate==undefined||payrollPayDate==''">Update</button>
          <button class="btn blue-btn btn-sm me-1" type="button" data-bs-dismiss="modal"
            (click)="updatevalchange=false">Close</button>


        </div>
      </div>
    </div>
  </div>
</div>


<!-- ////////////////Move To UNpaid////////////////// -->
<span id="OpenModal4" data-bs-target="#moveunpaid" data-bs-toggle="modal"></span>
<div class="modal fade " id="moveunpaid" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">

  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5><b>Unpay</b></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
                    <p>{{saveErr}}</p>
                    <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div> -->
        <div>
          <div class="row">
            <label>Do you Want To Unpay?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="text_right">
          <button class="btn blue-btn btn-sm me-1" type="button" [disabled]="IsButtonDisable"
            (click)="MovetoUnPaid()">Yes</button>
          <button class="btn blue-btn btn-sm me-1" type="button" data-bs-dismiss="modal"
            (click)="updatevalchange=false">Close</button>


        </div>
      </div>
    </div>
  </div>
</div>

<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Export as CSV</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="payexportclose">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <button class="btn blue-btn btn-sm mb-1" id="paycurrentprint" (click)="exportCsv('current')">
              Print Current page
            </button>
          </div>
          <div class="col-lg-6">
            <button class="btn blue-btn btn-sm mb-1" id="payallprint" (click)="exportCsv('all')">
              Print All page
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" id="payexportclosebtn">
          Close
        </button>
      </div>
    </div>
  </div>
</div>